<i18n>
[
    "product__productDetails--title",
    "product__readMore--label",
]
</i18n>

<template>
    <div class="o-text--caption">
        <p class="u-spacer--0pt5">
            {{ $t('product__productDetails--title') }}
        </p>
        <div class="c-product-details__content u-text--gray">
            {{ productDetails.longDescription }}
        </div>
        <UrbnModalLauncher
            v-if="productDetails"
            :modalOptions="pdpDetailsModal"
            type="link"
        >
            <span class="o-text--link">{{ $t('product__readMore--label') }}</span>
        </UrbnModalLauncher>
    </div>
</template>

<script>

import { MODALS } from '~modules/modals/js/modal-constants';

import UrbnModalLauncher from '~coreModules/modals/components/UrbnModalLauncher.vue';

export default {
    name: 'ProductDetails',
    components: {
        UrbnModalLauncher,
    },
    props: {
        productDetails: {
            type: Object,
            required: true,
        },
        colorCode: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        pdpDetailsModal: MODALS.pdpDetails,
    }),
};
</script>

<style lang="scss">
    .c-product-details {
        &__content {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
</style>
